import { render, staticRenderFns } from "./VideoOrderRow.vue?vue&type=template&id=4d2b8f90&scoped=true&"
import script from "./VideoOrderRow.vue?vue&type=script&lang=js&"
export * from "./VideoOrderRow.vue?vue&type=script&lang=js&"
import style0 from "./VideoOrderRow.vue?vue&type=style&index=0&id=4d2b8f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b8f90",
  null
  
)

export default component.exports